import { Link } from 'react-router-dom';
import Container from '@/components/base/Container';
import SectionLabel from '@/components/base/SectionLabel';
import Reveal from '@/components/base/Reveal';
import PerspectivesAccordion from './PerspectivesAccordion';
import { articles, perspectivePortraits } from '@/mocks/site';

export default function PerspectivesSection() {
  const items = articles.slice(0, 3).map((a, i) => ({
    slug: a.slug,
    title: a.title,
    excerpt: a.excerpt,
    category: a.category,
    date: a.date,
    image: i === 0 ? a.image : (perspectivePortraits[a.slug] ?? a.image),
  }));

  return (
    <section className="bg-background-50 py-20 md:py-28 lg:py-32">
      <Container>
        <SectionLabel index="05" label="Perspectives" />
        <div className="mt-12 flex flex-col gap-6 md:mt-16 md:flex-row md:items-end md:justify-between">
          <Reveal>
            <h2 className="font-heading text-4xl font-light leading-[1.05] tracking-[-0.02em] md:text-5xl">Ideas worth considering.</h2>
          </Reveal>
          <Link to="/insights" className="inline-flex cursor-pointer items-center gap-2 whitespace-nowrap font-label text-[11px] uppercase tracking-[0.14em] text-foreground-950 hover:text-primary-500">
            <i className="ri-arrow-right-line" /> <span className="ed-link">All insights</span>
          </Link>
        </div>

        <Reveal className="mt-14">
          <PerspectivesAccordion items={items} />
        </Reveal>
      </Container>
    </section>
  );
}